import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import { media } from 'styled-bootstrap-grid'

import { positions } from '../data'

const PositionList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const PositionItem = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
  .content {
    transition: background-color .4s, transform .4s;
    cursor: pointer;
    background: #F2FAF8;
    padding: 8px 16px;
    flex: 1;
    display: flex;
    align-items: center;
    i {
      color: #8598ad;
      font-size: 1.5rem;
      margin-right: 16px;
    }
    .right {
      border-left: 1px solid #E7EDEB;
      padding-left: 16px;
      .title {
        color: #4a4a4a !important;
        font-weight: ${fontWeight.bold};
        margin-bottom: 4px;
      }
      .total {
        color: #8898AB !important;
        font-weight: ${fontWeight.medium};
        opacity: 0.75;
      }
    }
  }
  ${media.md`
    .content {
      &:hover {
        /* box-shadow: 0 4px 8px rgba(0,0,0,.05); */
        background: #ffffdc;
      }
    }
  `}
  ${media.lg`
    /* width: calc(100% / 2); */
  `}
`

const Positions = ({ onClick }) => {
  return (
    <PositionList>
      {positions.map((position, index) => {
        return (
          <PositionItem onClick={onClick(position)} key={index}>
            <div className='content'>
              <i className={position.icon} />
              <div className='right'>
                <div className='title'>{position.title}</div>
                <div className='total'>{position.total} vị trí</div>
              </div>
            </div>
          </PositionItem>
        )
      })}
    </PositionList>
  )
}

export default Positions
